// extracted by mini-css-extract-plugin
export default {"Buttons":"Buttons_Buttons__Ttwfw","ButtonsStory":"Buttons_ButtonsStory__+EPQA"};